import { HomeQueries } from '@/graphql/queries/home.queries'
import { useGraphql } from '@/hooks/useGraphql'
import { ReservationHome } from '@/types/Homes'

export function useReservationHome({ homeId }: { homeId: number }) {
  const reservationHomeQuery = useGraphql<{ home: ReservationHome }>(
    HomeQueries.QUERY_KEYS.getReservationHome,
    HomeQueries.getReservationHome(),
    { id: homeId },
    {
      enabled: !!homeId,
    },
  )

  return reservationHomeQuery
}
